import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import AdminDashboard from './subscriptions/AdminDashboard';

const AdminSubscriptionDashboardPage = () => (
  <AdminLayout>
    <AdminDashboard />
  </AdminLayout>
);

export default AdminSubscriptionDashboardPage;
